<router-outlet></router-outlet>

@defer (when isBrowser) {
  <lu-main-bootstrap />
}
